import { SidebarStoreState } from "@/features/sidebar/types"
import { configureStore } from "@/lib/store"

export const sidebarStore = configureStore<SidebarStoreState>(
  () => ({
    isOpen: true, // Default state is open
  }),
  {
    persistOptions: {
      name: "sidebar-storage", // Name for the storage key
    },
  }
)
